/* import __COLOCATED_TEMPLATE__ from './banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();